import { RouteGuard } from '@/router/routeGuard';
import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    path: "/administrativo/usuarios",
    name: "ListaUsuarios",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/usuarios/ListagemUsuarios.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/relatorios/servicosveiculares",
    name: "RelatoriosServicosVeiculares",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/servicos-veiculares/RelatorioServicosVeiculares.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/relatorios/servicossaude",
    name: "RelatoriosServicosSaude",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/servicos-saude/RelatorioServicosSaude.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/relatorios/diretivo",
    name: "RelatorioDiretivo",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/diretivo/RelatorioDiretivo.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/relatorios/consulta-pagamento",
    name: "RelatorioConsultaPagamento",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/consulta-pagamento/RelatorioConsultaPagamento.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/cadastro/configuracoes",
    name: "Configuracoes",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/configuracoes/Configuracoes.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/cadastro/banco",
    name: "Banco",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/banco/Banco.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/comunicacao/upload/cadastro",
    name: "Upload",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/comunicacao/Upload.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/comunicacao/disparo/relatorio",
    name: "RelatorioDisparo",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/comunicacao/RelatorioDisparos.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/cadastro/segmento",
    name: "Segmento",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/segmento/Segmento.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/log-precificacao",
    name: "LogPrecificacao",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/log-precificacao/RelatorioLogPrecificacao.vue"),
	beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/mapa",
    name: "Mapa",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/servicos/Mapa.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/termo-de-uso",
    name: "TermoDeUso",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/termo-de-uso/TermoDeUso.vue"),
	  beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/relatorios/associados-inativos",
    name: "RelatoriosAssociadosInativos",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/associados-inativos/RelatorioAssociadosInativos.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/cadastro/oficinas",
    name: "ListaOficinas",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/cadastros/oficina/ListaOficinas.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/relatorios/frota/leads",
    name: "RelatoriosFrotaLeads",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/frota-leds/RelatorioFrotaLeds.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
  {
    path: "/administrativo/relatorios/frota/leads/consultar/:idLeads?",
    name: "ConsultarFrotaLeads",
    component: () => import(/* webpackChunkName: "administrativo" */ "@/views/private/administracao/frota-leds/ConsultarLeads.vue"),
    beforeEnter: RouteGuard.acessoAdministrativo
  },
]

export default routes;